<template>
  <v-container class="pa-0"  fluid>
    <component :is="routeItems[activeRoute].component" class=""></component>
  </v-container>
</template>

<script>
import { authRoute } from '@/router/routeRole'
import PreparedSentRequests from '@/views/messages/preparedSentRequests/PreparedSentRequests'
import PreparedSentRequestForm from '@/views/messages/preparedSentRequests/PreparedSentRequestForm'
import PreparedSentMessages from '@/views/messages/preparedSentMessages/PreparedSentMessages'
import PreparedSentMessageForm from '@/views/messages/preparedSentMessages/PreparedSentMessageForm'

export default {
  name: 'messagesTab',
  data() {
    return {
      selectedTab: null,
    }
  },
  computed: {
    routeItems() {
      return [
        {
          title: 'Rengiami ir pateikti pranešimai',
          route: 'adminMessagesPreparedSent',
          component: PreparedSentMessages,
        },
        {
          title: 'Pranešimas',
          route: 'adminMessageNew',
          component: PreparedSentMessageForm
        },
        {
          title: 'Pranešimas',
          route: 'adminMessageListNew',
          component: PreparedSentMessageForm
        },
        {
          title: 'Pradiniai prašymai',
          route: 'adminRequestsPreparedSent',
          component: PreparedSentRequests,
        },
        {
          title: 'Prašymas',
          route: 'adminRequestNew',
          component: PreparedSentRequestForm,
        },
        {
          title: 'Prašymas',
          route: 'adminRequestListNew',
          component: PreparedSentRequestForm,
        },
      ]
    },
    tabItems() {
      return this.routeItems.filter((item) => {
        return !item.hide && authRoute(item.route)
      })
    },
    activeTab: {
      set(value) {
        this.selectedTab = value
      },
      get() {
        return this.tabItems.findIndex(function (item, index) {
          return this.$route.matched.find((element) => {
            if (item.route === element.name) {
              return true
            }
          })
        }, this)
      },
    },
    activeRoute() {
      return this.routeItems.findIndex(function (item, index) {
        if (item.route === this.$route.name) {
          return true
        }
      }, this)
    },
  },
  created() {
    this.selectedTab = this.activeTab
  },
  methods: {
    gotoTab(item) {
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
